export const compressImageIfNeeded = (file) => {
    return new Promise((resolve, reject) => {
      // Preserve animated GIFs as raw data URLs (canvas flattens GIF animations)
      if (file.type === "image/gif" || file.name.toLowerCase().endsWith(".gif")) {
        const reader = new FileReader();
        reader.onload = () => resolve({ dataUrl: reader.result, fileName: file.name });
        reader.onerror = reject;
        reader.readAsDataURL(file);
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          let width = img.width;
          let height = img.height;
          const maxDim = 1920;

          const needsResize = width > maxDim || height > maxDim;
          const needsCompress = file.size > 3 * 1024 * 1024;

          // If already within 1920x1920 and under 3MB, use original data URL
          if (!needsResize && !needsCompress) {
            return resolve({ dataUrl: e.target.result, fileName: file.name });
          }

          if (width > height && width > maxDim) {
            height = Math.round((height * maxDim) / width);
            width = maxDim;
          } else if (height > maxDim) {
            width = Math.round((width * maxDim) / height);
            height = maxDim;
          }

          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          // Export as JPEG (0.85 quality) to ensure small file size and full carrier compatibility
          const compressedDataUrl = canvas.toDataURL("image/jpeg", 0.85);
          const baseName = file.name.substring(0, file.name.lastIndexOf(".")) || file.name;
          const outName = `${baseName}.jpg`;

          resolve({ dataUrl: compressedDataUrl, fileName: outName });
        };
        img.onerror = () => {
          resolve({ dataUrl: e.target.result, fileName: file.name });
        };
        img.src = e.target.result;
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
